// extracted by mini-css-extract-plugin
export default {"root":"_1eDfj","left":"-E8QK","right":"JwtPN"};